var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxxoPay03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 674.6 141.7",
    style: {
      enableBackground: "new 0 0 674.6 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#414959;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill:#414959;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,0l289.1,0c4.7,0,8.5,3.8,8.5,8.5l0,124.7c0,4.7-3.8,8.5-8.5,8.5H8.5c-4.7,0-8.5-3.8-8.5-8.5V8.5 C0,3.8,3.8,0,8.5,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,14.2 306.1,14.2 306.1,127.6 0,127.6 0,14.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.7,45.4c-14.1,0-25.5,11.5-25.5,25.5c0,14,11.5,25.5,25.5,25.5c14.1,0,25.5-11.5,25.5-25.5 C282.2,56.8,270.7,45.4,256.7,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.5,45.4C35.4,45.4,24,56.8,24,70.9c0,14,11.5,25.5,25.5,25.5c14,0,25.5-11.5,25.5-25.5 C75,56.8,63.5,45.4,49.5,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.8,21.3c-20.2,1.9-30.5,15.3-45,33l-14.8,18l24.8,28.3c5.9,8.7-4.8,17.8-11.8,9.8L181,84.3l-21.1,25.7 c-6.7,8.2-17.8-0.5-12.1-9.4l22.9-27.9l-15.9-18.1l10-11.8l15.8,17.8l13.2-16c6.4-7.8,12.8-17.6,21.3-23.1H0v99.2h55.4 c20.2-1.9,30.5-15.3,45-33l14.8-18L90.5,41.2c-5.9-8.7,4.8-17.8,11.8-9.8l22.9,26.1l21.1-25.7c6.7-8.2,17.8,0.5,12.1,9.4 l-22.9,27.9l15.9,18.1l-10,11.8l-15.8-17.8l-13.2,16C106,105.1,99.5,115,91,120.5h215.1V21.3H250.8z M89.9,70.9 c0,22.2-18.1,40.4-40.4,40.4c-22.3,0-40.4-18.1-40.4-40.4c0-22.3,18.1-40.4,40.4-40.4C71.7,30.5,89.9,48.6,89.9,70.9z  M256.7,111.3c-22.2,0-40.4-18.1-40.4-40.4c0-22.3,18.1-40.4,40.4-40.4c22.3,0,40.4,18.1,40.4,40.4 C297.1,93.1,278.9,111.3,256.7,111.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 348.7,
    y: 0,
    className: "st2",
    width: 7.1,
    height: 141.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M486.8,53.8c0-7.1-2.3-13.5-7.1-18.3c-6.7-6.7-17-10-33.7-10h-30.5l-24.4,90.7h30.3l6.6-24.6h12.8 C469.7,91.6,486.8,76.4,486.8,53.8z M439.4,70h-5.4l5.3-20.2h5.7c3.4,0,7,0.8,9.1,2.9c1.4,1.4,2.2,3.4,2.2,5.3 C456.2,64.8,450.9,70,439.4,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M526.7,25.5l-62.3,90.7h32.8l7.8-12.1h31.5l1.5,12.1h32l-13.6-90.7H526.7z M518.5,82.8l14-21.9l2.4,21.9 H518.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "638.8,25.5 615.2,55.8 607.8,25.5 575.9,25.5 593.7,81.6 584.5,116.2 614.8,116.2 623.1,85.4  674.6,25.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxxoPay03);
export default __webpack_public_path__ + "static/media/oxxo-pay-03.1250ec79f44e252eec229f1c363019e0.svg";
export { ForwardRef as ReactComponent };